import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { key: 5 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_quiz_loading_view = _resolveComponent("quiz-loading-view")!
  const _component_quiz_passed = _resolveComponent("quiz-passed")!
  const _component_quiz_retry = _resolveComponent("quiz-retry")!
  const _component_quiz_failed = _resolveComponent("quiz-failed")!
  const _component_quiz_initiation = _resolveComponent("quiz-initiation")!
  const _component_quiz_question = _resolveComponent("quiz-question")!

  return (!_ctx.isQuizLoaded)
    ? (_openBlock(), _createBlock(_component_quiz_loading_view, { key: 0 }))
    : (_ctx.isQuizPassed)
      ? (_openBlock(), _createBlock(_component_quiz_passed, { key: 1 }))
      : (_ctx.isQuizFailed)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
            (_ctx.isFailedAndHaveRetry)
              ? (_openBlock(), _createBlock(_component_quiz_retry, { key: 0 }))
              : (_openBlock(), _createBlock(_component_quiz_failed, { key: 1 }))
          ], 64))
        : (_ctx.isFirstTimeQuiz)
          ? (_openBlock(), _createBlock(_component_quiz_initiation, { key: 3 }))
          : (_ctx.isQuizInProgress)
            ? (_openBlock(), _createBlock(_component_quiz_question, { key: 4 }))
            : (_openBlock(), _createElementBlock("div", _hoisted_1, " Unknown state "))
}